import type { ReactNode } from "react";
import { useAccent } from "./accent";

interface GlassCardProps {
  children: ReactNode;
  className?: string;
  /** Adds a soft chapter-accent glow behind the card. */
  glow?: boolean;
}

export function GlassCard({ children, className = "", glow = false }: GlassCardProps) {
  const [from] = useAccent();
  return (
    <div
      className={`glass ${className}`}
      style={
        glow
          ? {
              boxShadow: `0 8px 32px rgba(0,0,0,0.35), 0 0 48px -8px ${from}55, inset 0 1px 0 rgba(255,255,255,0.08)`,
            }
          : undefined
      }
    >
      {children}
    </div>
  );
}
